import { writeStorage } from '@rehooks/local-storage';
import { UIStore } from "./store";

export function checklogin()  : boolean{
 


    let storedLoginstate = localStorage.getItem('LoggedinState');
    if(storedLoginstate === "true"){

        return true;    
      }

    return false;

    
}

export function setlogin(loginstatus:boolean){

  localStorage.setItem("LoggedinState", loginstatus.toString()); 


}